<template>
  <div>
    <div class="search-head">
      <img :src="img" @click="goBack()"/>
      <div class="search-head-body">
        <input placeholder="搜索产品" v-model="key" @click="goToSearch()" @keyup.enter="search()"/>
        <button @click="search()">搜索</button>
      </div>
    </div>
    <div style="height: 3.2rem"></div>
  </div>
</template>
<script>
  export default{
    name:'SearchHead',
    props:['type','keywords'],
    data(){
      return{
        key:this.keywords,
        img:require("../../../static/img/H5_home_black.png")
      }
    },
    components:{

    },
    created(){
    },
    mounted(){
      if(this.isIos){
        document.getElementsByClassName("search-head-body")[0].getElementsByTagName("input")[0].style.width='14.5rem';
        document.getElementsByClassName("search-head-body")[0].getElementsByTagName("input")[0].style.lineHeight='2rem';
        document.getElementsByClassName("search-head")[0].getElementsByTagName("img")[0].style.marginTop='1rem';
      }
    },
    watch:{
      key:function(key){
        this.getLikeWord(key);
      }
    },
    methods:{
      getLikeWord(key){
        if(this.type==this.headType.searchHead){
          this.watcher.$emit('getlikeword',key);
        }
      },
      goBack(){
        if(this.type==this.headType.searchResultHead){
          this.jumpToView(this.headType.searchHead,'',this.key);
        }else{
          this.public.keyParam='';
          this.public.key = "";
          this.jumpToView(this.headType.h5Main);
        }
      },
      search(){
        if(this.key && this.key!=''){
          if(this.type==this.headType.searchHead){
            var hs = window.localStorage.getItem("history")?JSON.parse(window.localStorage.getItem("history")):[];
            if(hs.indexOf(this.key)<= -1){
              hs.unshift(this.key);
            }
            window.localStorage.setItem("history",JSON.stringify(hs));
            this.jumpToView(this.headType.searchResultHead,"k="+this.key,this.key)
          }else{
            this.public.key = this.key;
            this.public.keyParam = "k="+this.key;
            this.public.pageNumParam = '';

            this.public.toggleReload();
          }
        }
      },
      goToSearch(){
        if(this.type==this.headType.searchResultHead){
          this.jumpToView(this.headType.searchHead,'',this.key);
        }
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// SearchHeader.vue?29a5a95f